<template>
  <div>
    <!--修改物流方式-->
    <Modal v-model="modifyMailingMethodModal" width="1000" :title="$t('key1004281')" :mask-closable="false" @on-visible-change="visibleFn1">
      <Form class="setAllMarkRead" style="margin-top:10px" @submit.native.prevent>
        <Row>
          <Col :span="14">
            <Form-item :label="$t('key1004282')" :label-width="160">
              <Cascader
                v-model="value2"
                :load-data="loadData"
                @on-change="changeShippingMethod"
                @on-visible-change="(value)=> showShippingData(value, false, null, ymsWarehouseId)"
                :data="shippingMethodData"
                filterable
                change-on-select>
              </Cascader>
            </Form-item>
          </Col>
          <Col :span="9"
            v-if="apiInterfaceStatus !== 'API_AE_LG' && apiInterfaceStatus !== 'API_EDIS' && apiInterfaceStatus !== 'API_VOVA'">
            <Form-item :label="$t('key1004283')" :label-width="160">
              <Select v-model="shippingAccountModel" filterable>
                <Option
                  v-for="(item,index) in carrierAccount"
                  v-if="item.carrierAccountId !== null"
                  :key="index"
                  :value="item.carrierAccountId">
                  {{ item.account }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div class="matchLogisticSetting">
        <h6>{{ $t('key1004285') }}</h6>
      </div>
      <Form class="setAllMarkRead white-space-nowrap-form" style="margin-top:10px" @submit.native.prevent>
        <Row>
          <template v-for="(item,index) in carrierBaseSetting">
            <!--<Col :span="12" >
              <Form-item  :label="item.paramName" :label-width="160">
                <span>{{ item.paramValue }}</span>
              </Form-item>
            </Col>-->
            <Col :span="12" v-if="item.paramType !== 'hide'">
              <Form-item :label="item.paramName" :label-width="160">
                <Radio-group v-model="shippingMethodModel[index].paramValue" v-if="item.paramType === 'radio'">
                  <Radio :label="sItem.itemValue" v-for="(sItem,n) in item.dictionarys" :key="n">
                    <span>{{ sItem.itemName }}</span>
                  </Radio>
                </Radio-group>
                <Input v-if="item.paramType === 'input'" clearable v-model.trim="shippingMethodModel[index].paramValue"></Input>
                <Checkbox-group v-model="shippingMethodModel[index].paramValue" v-if="item.paramType === 'checkbox'">
                  <Checkbox v-for="(sItem,n) in item.dictionarys" :key="n" :label="sItem.itemValue">
                    <span>{{ sItem.itemName }}</span>
                  </Checkbox>
                </Checkbox-group>
                <Select v-if="item.paramType === 'select'" v-model="shippingMethodModel[index].paramValue" filterable>
                  <Option
                    v-for="(sItem,n) in item.dictionarys"
                    :key="n"
                    :value="sItem.itemValue"> {{ sItem.itemName }}
                  </Option>
                </Select>
                <span v-if="item.paramType === 'readOnly'">{{ item.paramValue }}</span>
              </Form-item>
            </Col>
          </template>
        </Row>
      </Form>
      <Table
        highlight-row
        border
        :loading="tableLoading"
        :columns="columns1"
        :data="data1"
        max-height="550"
        @on-selection-change="checkDataFn">
      </Table>
      <template #footer>
        <Button @click="modifyMailingMethodModal = false">{{ $t('key1000112') }}</Button>
        <Button @click="modifyShipping" type="primary">{{ $t('key1004286') }}</Button>
      </template>
    </Modal>
    <!--失败数据-->
    <Modal v-model="modal1" width="1000" :title="$t('key1004284')">
      <Table :columns="columns2" :data="data2"></Table>
      <template #footer>
        <Button type='primary' @click="modal1=false">{{ $t('key1000248') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import {setConfigCharacters} from "@/utils/common";

export default {
  name: 'modifyMailingMethodModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      value2: [],
      apiInterfaceStatus: null,
      carrierAccount: [],
      carrierBaseSetting: [],
      modal1: false,
      modifyMailingMethodModal: false,
      columns1: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'No.',
          type: 'index',
          width: 70,
          align: 'center'
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'pickingNo',
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004274'),
          align: 'center',
          key: 'logisticsDealerName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004275'),
          align: 'center',
          key: 'logisticsMailName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004276'),
          align: 'center',
          key: 'consigneeCountry'
        }
      ],
      columns2: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          width: 140
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004277'),
          key: 'error'
        }
      ],
      data1: [],
      data2: [],
      ymsWarehouseId: null
    };
  },
  props: {
    packageData: {
      default: [] // 数据
    }
  },
  methods: {
    // 清空物流数据
    resetShip() {
      this.shippingMethodData = [];
      this.carrierAccount = [];
      this.carrierBaseSetting = [];
      this.shippingMethodModel = [];
      this.value2 = [];
      this.shippingAccountModel = null;
    },
    // 确认修改按钮
    modifyShipping() {
      let v = this;
      if (this.checkData.length < 1) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004278'));
        return;
      }
      if (this.value2.length < 1) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004279'));
        return;
      }
      let keyList = ['API_AE_LG', 'API_EDIS', 'API_VOVA', 'api_joomLogistics'];
      if (!v.shippingAccountModel && !keyList.includes(v.apiInterfaceStatus)) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004280'));
        return false;
      }
      let apiUrl = api.put_ymsPackageInfo_updateCarrierInfo;
      let params = {
        carrierAccountId: v.shippingAccountModel,
        carrierId: v.value2[0],
        carrierShippingMethodParams: v.shippingMethodModel,
        shippingMethodId: v.value2[1][0],
        ymsPackageIds: v.checkData.map(i => i.ymsPackageId)
      };
      v.tableLoading = true;
      v.axios.put(apiUrl, params).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.$emit('getList');
          v.modifyMailingMethodModal = false;
          if (response.data.datas && response.data.datas.length > 0) {
            v.modal1 = true;
            v.data2 = response.data.datas;
          } else {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          }
        }
      });
    },
    // 监听窗口
    visibleFn1(open) {
      this.tableLoading = true;
      if (open) {
        this.resetShip();
        this.checkData = [];
        this.data1 = this.packageData;
        this.tableLoading = false;
      } else {
        this.data1 = [];
      }
    },
    // 勾选列表数据
    checkDataFn(data) {
      this.checkData = data;
    },
    // 选择物流方式
    changeShippingMethod(value, data) {
      let v = this;
      v.carrierAccount = [];
      if (value.length === 0) return false;
      v.shippingMethodModel = [];
      v.shippingAccountModel = null;
      v.apiInterfaceStatus = data[0].apiInterface; // 存一下这个字段，当它为速卖通线上发货(API_AE_LG),eDIS物流(API_EDIS)的时候，不显示账号
      if (value.length === 2) {
        v.getCarrierBaseSettingApiMatch(value[1][0]);
        if (value[1][1] !== null) {
          v.carrierAccount = value[1][1];
        }
      }
      setTimeout(() => {
        v.value2 = null;
        v.value2 = value;
      });
    }
  }
};
</script>

<style>
.setAllMarkRead .ivu-form-item {
  margin-bottom: 10px;
}
</style>
<style scoped></style>
